import { render, staticRenderFns } from "./EmailRehabServiceCard.vue?vue&type=template&id=482ea970&scoped=true"
import script from "./EmailRehabServiceCard.vue?vue&type=script&lang=js"
export * from "./EmailRehabServiceCard.vue?vue&type=script&lang=js"
import style0 from "./EmailRehabServiceCard.vue?vue&type=style&index=0&id=482ea970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ea970",
  null
  
)

export default component.exports